export default __webpack_public_path__ + "static/media/data.2d3fe204.svg";